import { render, staticRenderFns } from "./PersonSelectedModal.vue?vue&type=template&id=0489a5c3&"
import script from "./PersonSelectedModal.vue?vue&type=script&lang=js&"
export * from "./PersonSelectedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0489a5c3')) {
      api.createRecord('0489a5c3', component.options)
    } else {
      api.reload('0489a5c3', component.options)
    }
    module.hot.accept("./PersonSelectedModal.vue?vue&type=template&id=0489a5c3&", function () {
      api.rerender('0489a5c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chooseSeat/ActivityManage/modules/PersonSelectedModal.vue"
export default component.exports